import React, { useState } from "react"
import ReactDOM from "react-dom"
import Modal from "./ImgDisplayModal/Modal"
import OverlayModal from "./ImgDisplayModal/OverlayModal"
import "./ImgCard.css"

const ImgCard = (props) => {
  const [isActive, setState] = useState(false)

  const openModalHandler = () => setState(true)
  const closeModalHandler = () => setState(false)

  return (
    <React.Fragment>
      <div
        className="ImgCard"
        onMouseOver={props.hoverEffecthandler}
        onFocus={() => 0}
        onMouseOut={props.hoverEffecthandler}
        onBlur={() => 0}
        onClick={openModalHandler}
        id={props.element.id}
        style={{
          backgroundImage: `url(${props.element.img})`
        }}
      >
        <div className="readMore">
          <p className="knowMore">Know More</p>
          <p className="readMoreContent">{props.element.description}</p>
        </div>
      </div>

      {isActive &&
        ReactDOM.createPortal(
          <Modal
            closeModalHandler={closeModalHandler}
            image={props.element.img}
          />,
          document.getElementById("modal-root")
        )}
      {isActive &&
        ReactDOM.createPortal(
          <OverlayModal closeModalHandler={closeModalHandler} />,
          document.getElementById("overlay-modal-root")
        )}
    </React.Fragment>
  )
}

export default ImgCard
